import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import style from "./PartnersVendingMapping.module.css";
import { requester } from 'App';
import CustomButton from 'components/buttons/CustomButton';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Container from 'layouts/container/Container';
import Center from 'layouts/wrapper/Center';
import P from 'components/P';
import MachineCard from 'routes/admin/vending/MachineCard';
import useLocalStorage from 'shared/hooks/useLocalStorage';
import { getTokenPayload } from 'shared/utils/Utils';

const PartnersVendingMapping = () => {
    const { t } = useTranslation();
    const [columns, setColumns] = useState();
    const [isMounted, setMounted] = useState(false);
    const [machine, setMachine] = useState();

    const [token, setToken] = useLocalStorage("token");

    const payload = getTokenPayload(token);

    console.log(payload)

    useEffect(() => {
        requester.findAllStoresByVendorUserName((result) => {
            if (result.data) {
                const temp = result.data;
                const transformedData = {};
                transformedData["notRegistered"] = {
                    title: "미등록",
                    items: []
                };
                temp.forEach(item => {
                    transformedData[item.id] = {
                        title: item.storeName,
                        items: []
                    };
                });
                setColumns(transformedData);
            }
            setMounted(true);
        });
    }, []);

    useEffect(() => {
        if (isMounted) {
            // const data = { userName: payload.userName }
            const data = { vendorName: payload.userName }
            requester.findAllVendingByVendorName(data, (result) => {
                console.log(result.data)
                setMachine(result.data);
            })
        }
    }, [isMounted])

    useEffect(() => {
        if (machine) {
            const transformedData = {
                "notRegistered": {
                    "title": "미등록",
                    "items": []
                }
            };

            Object.keys(columns).forEach(key => {
                if (key !== "notRegistered") {
                    transformedData[key] = {
                        ...columns[key],
                        items: [...columns[key].items]
                    };
                }
            });

            machine.forEach(m => {
                if (m.storeId && transformedData[m.storeId]) {
                    transformedData[m.storeId].items.push(m);
                    transformedData[m.storeId].items.sort((a, b) => a.orderNo - b.orderNo);
                } else {
                    transformedData["notRegistered"].items.push(m);
                    transformedData["notRegistered"].items.sort((a, b) => a.orderNo - b.orderNo);
                }
            });

            setColumns(transformedData);
        }
    }, [machine]);

    const onDragEnd = (result) => {
        const { source, destination } = result;

        if (!destination) return;

        const sourceColumn = columns[source.droppableId];
        const destColumn = columns[destination.droppableId];
        const sourceItems = [...sourceColumn.items];
        const destItems = [...destColumn.items];
        const [removed] = sourceItems.splice(source.index, 1);

        removed.storeId = destination.droppableId === "notRegistered" ? null : destination.droppableId;

        if (source.droppableId !== destination.droppableId) {
            destItems.splice(destination.index, 0, removed);
            const newFinishItems = destItems.map((item, index) => ({
                ...item,
                orderNo: index + 1,
            }));

            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems.map((item, index) => ({
                        ...item,
                        orderNo: index + 1,
                    })),
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: newFinishItems,
                },
            });
        } else {
            sourceItems.splice(destination.index, 0, removed);
            const newItems = sourceItems.map((item, index) => ({
                ...item,
                orderNo: index + 1,
            }));

            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: newItems,
                },
            });
        }
    };

    const onUpdateClick = () => {
        const itemsToUpdate = Object.values(columns).flatMap(column => column.items.map(item => ({
            ...item,
        })));

        requester.updateVendingList(itemsToUpdate, (result) => {
            if (result.code === 0) {
                toast.success(t("수정되었습니다"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"}>
                        기기매핑
                    </P>
                </Center>
                {isMounted && (
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <div className={style.container}>
                                <div className={style.column}>
                                    {Object.entries(columns).map(([columnId, column], index) => {
                                        return (
                                            <Droppable key={columnId} droppableId={columnId}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        className={`${style.list} ${columnId === 'notRegistered'
                                                            ? style.firstList
                                                            : style.scrollableList
                                                            }`}
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        <span className={style.title}>{column.title}</span>

                                                        {column.items.map((item, index) => (
                                                            <MachineCard key={item.id} item={item} index={index} />
                                                        ))}
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        );
                                    })}
                                </div>
                            </div>
                        </DragDropContext>
                    </div>
                )}
                <CustomButton text={"적용"} onClick={onUpdateClick} />
            </Container>
        </Container>
    );
}

export default PartnersVendingMapping;